export const ADS_PAGE_SIZE = 100;

export const collectPagedContent = async (fetchPage, pageSize = ADS_PAGE_SIZE) => {
    const all = [];
    let page = 0;
    let total = Number.POSITIVE_INFINITY;

    while (all.length < total && page < 50) {
        const result = await fetchPage(page, pageSize);
        const data = result?.Data;
        if (Array.isArray(data)) {
            return data;
        }
        const content = Array.isArray(data?.content) ? data.content : [];
        const reported = data?.totalElements;
        total = reported != null ? Number(reported) : all.length + content.length + (content.length < pageSize ? 0 : pageSize);
        all.push(...content);
        if (content.length < pageSize) {
            break;
        }
        page += 1;
    }

    return all;
};
